<template>
  <div id="app">
    <GameOfLife />
  </div>
</template>

<script>
  import GameOfLife from './components/game-of-life/GameOfLife.vue';

  export default {
    name: 'App',
    components: {
      GameOfLife,
    },
  };
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
